import React from 'react';
import FieldMeta from '../FieldMeta';

/**
 * Wrapper for rendering an option
 * */
const FieldWrapper = ({ field, children }) => (
  <div className="ft-amf-option">
    <div className="ft-amf-title-container flex-row items-center mb-0.8">
      <FieldMeta field={field} />
    </div>
    <div className="dropdown-container">{children}</div>
  </div>
);

FieldWrapper.displayName = 'FieldWrapper';

export default FieldWrapper;
